import React from 'react'

const CongratulationEmail = () => {
    return (
        <div className="bg-white p-4 mt-6 rounded">
            <div className="flex flex-col justify-center m-8 items-center">
                {/* <img src="tik.png" alt="tik" className="w-20 h-20"/> */}
                <p className="font-bold text-4xl px-4">Kindly check your email </p>
                {/* <p className="font-bold px-4">has been updated</p> */}
            </div>
        </div>
    )
}

export default CongratulationEmail
